'use strict';

const DB_NAME = `plaid-offline`;
const STORE_NAME = `image-queue`;
const DB_VERSION = 1;

let db;

const openDB = () => {
  if (db) return Promise.resolve(db);
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = (e) => {
      e.target.result.createObjectStore(STORE_NAME, { keyPath: `id`, autoIncrement: true });
    };
    req.onsuccess = (e) => {
      db = e.target.result;
      db.onversionchange = () => { db.close(); db = null; };
      db.onclose = () => { db = null; };
      resolve(db);
    };
    req.onerror = () => reject(req.error);
  });
};

export const enqueueImage = (taskItemId, taskId, fieldId, file) => {
  return openDB().then((database) => new Promise((resolve, reject) => {
    const tx = database.transaction(STORE_NAME, `readwrite`);
    const req = tx.objectStore(STORE_NAME).add({ taskItemId, taskId, fieldId, file, timestamp: Date.now() });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  }));
};

export const getPendingImages = () => {
  return openDB().then((database) => new Promise((resolve, reject) => {
    const req = database.transaction(STORE_NAME, `readonly`).objectStore(STORE_NAME).getAll();
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  }));
};

export const getPendingCountForItem = (taskItemId) => {
  return getPendingImages().then((all) => all.filter((e) => e.taskItemId === taskItemId).length);
};

export const removeQueuedImage = (id) => {
  return openDB().then((database) => new Promise((resolve, reject) => {
    const req = database.transaction(STORE_NAME, `readwrite`).objectStore(STORE_NAME).delete(id);
    req.onsuccess = () => resolve();
    req.onerror = () => reject(req.error);
  }));
};



// WEBPACK FOOTER //
// ./src/helpers/ImageQueueHelper.js